import { Button, ButtonProps } from '@mui/material';
import { ChangeEvent, MouseEvent } from 'react';

import { VisuallyHiddenFileInput } from './Form.styled';

type UploadButtonProps = {
  accept?: string;
  multiple?: boolean;
  onChange?: (files: FileList | null) => void;
  isRounded?: boolean;
} & Omit<ButtonProps, 'onChange'>;

export function UploadButton({
  children,
  accept,
  multiple,
  onChange,
  ...props
}: UploadButtonProps) {
  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.currentTarget.files);
  };

  const handleOnClick = (e: MouseEvent<HTMLInputElement>) => {
    (e.target as HTMLInputElement).value = '';
  };

  return (
    <Button
      component="label"
      variant="contained"
      tabIndex={-1}
      fullWidth
      {...props}
    >
      <VisuallyHiddenFileInput
        multiple={multiple}
        accept={accept}
        onChange={handleOnChange}
        onClick={handleOnClick}
      />
      {children}
    </Button>
  );
}
